/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonaResDto } from '../../models/persona-res-dto';

export interface PersoneControllerGetOnePersoneById$Params {
  id: number;
}

export function personeControllerGetOnePersoneById(
  http: HttpClient,
  rootUrl: string,
  params: PersoneControllerGetOnePersoneById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PersonaResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    personeControllerGetOnePersoneById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonaResDto>;
      }),
    );
}

personeControllerGetOnePersoneById.PATH = '/admin/persona/id/{id}';
